import { useState } from 'react';

export const useTabEmptyState = (activeTab: string) => {
  const [trackedTab, setTrackedTab] = useState(activeTab);
  const [isEmpty, setIsEmpty] = useState(false);

  // Reset during render so the previous tab's value never paints
  if (activeTab !== trackedTab) {
    setTrackedTab(activeTab);
    setIsEmpty(false);
  }

  return [isEmpty, setIsEmpty] as const;
};
